// import React, { useState, useCallback, useMemo } from "react";
// import { Button } from "@shared/ui/button";
// import { Input } from "@shared/ui/input";
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shared/ui/select";
// import { Checkbox } from "@shared/ui/checkbox";
// import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
// import { ScrollArea } from "@shared/ui/scroll-area";
// import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@shared/ui/table";
// import {
//   CheckCircleIcon,
//   AlertTriangleIcon,
//   Loader2,
//   Edit,
//   Save,
//   X,
//   Filter,
// } from "lucide-react";
// import { toast } from "@shared/ui/use-toast";
// import { useUpdateIdEntity } from "@features/onboarding/utility-setup/hooks";

// interface Step3Props {
//   validationData: any[];
//   filteredValidationData: any[];
//   getTableColumns: () => string[];
//   handleImport: () => void;
//   isUploading: boolean;
//   setStep: (step: number) => void;
//   isEditMode: boolean;
//   setIsEditMode: (value: boolean) => void;
//   selectedRows: Set<number>;
//   setSelectedRows: (value: Set<number>) => void;
//   bulkAssignValue: string;
//   setBulkAssignValue: (value: string) => void;
//   parentEntityOptions: Array<{ value: string; label: string }>;
//   editingRow: number | null;
//   setEditingRow: (value: number | null) => void;
//   editValues: any;
//   setEditValues: (value: any) => void;
//   setValidationData: (value: any[]) => void;
//   validationFilter?: string;
//   setValidationFilter?: (value: string) => void;
//   dataUploadId: number | null;
// }

// export const Step3Component: React.FC<Step3Props> = ({
//   validationData,
//   filteredValidationData,
//   getTableColumns,
//   handleImport,
//   isUploading,
//   setStep,
//   isEditMode,
//   setIsEditMode,
//   selectedRows,
//   setSelectedRows,
//   bulkAssignValue,
//   setBulkAssignValue,
//   parentEntityOptions,
//   editingRow,
//   setEditingRow,
//   editValues,
//   setEditValues,
//   setValidationData,
//   validationFilter = "all",
//   setValidationFilter,
//   dataUploadId
// }) => {
//   console.log("Step3Component rendered with validationData:", validationData);
//   console.log("dataUploadId at step 3:", dataUploadId);

//   const updateEntityMutation = useUpdateIdEntity();

//   // Memoize filtered data to prevent recalculation on every render
//   const currentFilteredData = useMemo(() => {
//     if (validationFilter === "all") return validationData;
//     return validationData.filter((row) => row.status === validationFilter);
//   }, [validationData, validationFilter]);

//   // Memoize validation stats to prevent recalculation
//   const validationStats = useMemo(() => ({
//     valid: validationData.filter((d) => d.status === "valid").length,
//     warning: validationData.filter((d) => d.status === "warning").length,
//     error: validationData.filter((d) => d.status === "error").length,
//   }), [validationData]);

//   // Optimized checkbox selection handlers
//   const handleSelectAll = useCallback((checked: boolean) => {
//     if (checked) {
//       const allIndices = new Set(currentFilteredData.map((_, index) => index));
//       setSelectedRows(allIndices);
//     } else {
//       setSelectedRows(new Set());
//     }
//   }, [currentFilteredData, setSelectedRows]);

//   const handleRowSelect = useCallback((index: number, checked: boolean) => {
//     setSelectedRows(prev => {
//       const newSelectedRows = new Set(prev);
//       if (checked) {
//         newSelectedRows.add(index);
//       } else {
//         newSelectedRows.delete(index);
//       }
//       return newSelectedRows;
//     });
//   }, [setSelectedRows]);

//   // Optimized edit mode toggle
//   const handleEditModeToggle = useCallback(() => {
//     setIsEditMode(!isEditMode);
//     setEditingRow(null);
//     setEditValues({});
//     setSelectedRows(new Set());
//     setBulkAssignValue("");
//   }, [isEditMode, setIsEditMode, setEditingRow, setEditValues, setSelectedRows, setBulkAssignValue]);

//   // CREATE SIMPLIFIED PAYLOAD FROM SELECTED DATA
//   const createPayloadFromSelectedData = useCallback(() => {
//     const selectedData: any[] = [];

//     selectedRows.forEach((selectedIndex) => {
//       const rowData = currentFilteredData[selectedIndex];
//       if (rowData) {
//         selectedData.push({
//           tags: rowData.tags || "",
//           description: rowData.description || "",
//           entity_name: rowData.entityName || rowData.entity_name || "",
//           parent_name: parentEntityOptions.find(
//             (opt) => opt.value === bulkAssignValue
//           )?.label || bulkAssignValue,
//           configuration_code: rowData.configurationCode || rowData.configuration_code || 0,
//         });
//       }
//     });

//     return selectedData;
//   }, [selectedRows, currentFilteredData, parentEntityOptions, bulkAssignValue]);

//   // HANDLE BULK ASSIGNMENT WITH DATA REPLACEMENT
//   const handleBulkAssignment = useCallback(() => {
//     if (!bulkAssignValue) {
//       toast.error("Please select a name to assign");
//       return;
//     }

//     if (selectedRows.size === 0) {
//       toast.error("Please select at least one row");
//       return;
//     }

//     if (!dataUploadId) {
//       toast.error("Data upload ID is missing");
//       return;
//     }

//     const payload = createPayloadFromSelectedData();
//     console.log("Simplified Bulk Assignment Payload:", payload);

//     updateEntityMutation.mutate(
//       {
//         id: dataUploadId,
//         payload: payload
//       },
//       {
//         onSuccess: (response) => {
//           console.log("✅ Mutation successful, response:", response);

//           // Replace validation data with API response
//           if (response?.result && Array.isArray(response.result)) {
//             // Transform API response to match validation data structure
//             const transformedData = response.result.map((item: any, index: number) => ({
//               ...item,
//               entityName: item.entityName,
//               parentName: item.parentName,
//               configurationCode: item.configurationCode,
//             }));

//             // Replace the entire validation data with the response
//             setValidationData(transformedData);

//             // Clear selections and reset state
//             setSelectedRows(new Set());
//             setBulkAssignValue("");
//             setIsEditMode(false);

//           }
//         },
//         onError: (error) => {
//           console.error("❌ Mutation failed:", error);
//           toast.error("Failed to update records. Please try again.");
//         }
//       }
//     );
//   }, [
//     bulkAssignValue,
//     selectedRows.size,
//     dataUploadId,
//     createPayloadFromSelectedData,
//     updateEntityMutation,
//     setValidationData,
//     setSelectedRows,
//     setBulkAssignValue,
//     setIsEditMode,
//     parentEntityOptions
//   ]);

//   // Memoize table columns to prevent recalculation
//   const tableColumns = useMemo(() => getTableColumns(), [getTableColumns]);

//   // Optimize cell edit handler
//   const handleCellEdit = useCallback((index: number, column: string) => {
//     if (isEditMode && column === "parentName") {
//       setEditingRow(index);
//       setEditValues({ ...currentFilteredData[index] });
//     }
//   }, [isEditMode, currentFilteredData, setEditingRow, setEditValues]);

//   // Optimize edit value change
//   const handleEditValueChange = useCallback((column: string, value: string) => {
//     setEditValues(prev => ({
//       ...prev,
//       [column]: column === "parentName"
//         ? parentEntityOptions.find(opt => opt.value === value)?.label || value
//         : value,
//     }));
//   }, [setEditValues, parentEntityOptions]);

//   return (
//     <div className="space-y-6">
//       <Card>
//         <CardHeader>
//           <div className="flex items-center justify-between">
//             <CardTitle className="text-lg">Step 3: Review & Fix Data</CardTitle>
//             <div className="flex items-center gap-2">
//               {/* Status Filter Dropdown */}
//               <div className="flex items-center gap-2">
//                 <Filter className="w-4 h-4 text-gray-500" />
//                 <Select
//                   value={validationFilter}
//                   onValueChange={setValidationFilter}
//                 >
//                   <SelectTrigger className="w-32">
//                     <SelectValue placeholder="Filter by status" />
//                   </SelectTrigger>
//                   <SelectContent
//                     position="popper"
//                     side="bottom"
//                     align="end"
//                     sideOffset={4}
//                   >
//                     <SelectItem value="all">All</SelectItem>
//                     <SelectItem value="valid">Valid</SelectItem>
//                     <SelectItem value="warning">Warning</SelectItem>
//                     <SelectItem value="error">Error</SelectItem>
//                   </SelectContent>
//                 </Select>
//               </div>

//               <Button
//                 variant={isEditMode ? "destructive" : "outline"}
//                 size="sm"
//                 onClick={handleEditModeToggle}
//               >
//                 {isEditMode ? (
//                   <>
//                     <X className="w-4 h-4 mr-2" />
//                     Exit Edit Mode
//                   </>
//                 ) : (
//                   <>
//                     <Edit className="w-4 h-4 mr-2" />
//                     Edit Mode
//                   </>
//                 )}
//               </Button>
//             </div>
//           </div>
//         </CardHeader>
//         <CardContent>
//           <div className="bg-gray-50 p-4 rounded-lg mb-4">
//             <div className="flex items-center justify-between mb-2">
//               <h3 className="font-medium">Validation Results</h3>
//             </div>
//             <div className="flex gap-4 text-sm">
//               <span className="text-green-600 flex items-center gap-1">
//                 <CheckCircleIcon className="w-4 h-4" />
//                 {validationStats.valid} Valid
//               </span>
//               <span className="text-orange-600 flex items-center gap-1">
//                 <AlertTriangleIcon className="w-4 h-4" />
//                 {validationStats.warning} Warnings
//               </span>
//               <span className="text-red-600 flex items-center gap-1">
//                 <AlertTriangleIcon className="w-4 h-4" />
//                 {validationStats.error} Errors
//               </span>
//             </div>
//             <p className="text-xs text-gray-600 mt-2">
//               Showing {currentFilteredData.length} of {validationData.length} records
//               {validationFilter !== "all" && ` (filtered by ${validationFilter})`}.
//               Fix errors and warnings before importing.
//               {isEditMode
//                 ? " Edit mode is active - select rows for bulk actions or click individual cells to edit."
//                 : " Click Edit Mode to modify data."}
//             </p>
//           </div>

//           {/* Bulk Actions Panel */}
//           {isEditMode && selectedRows.size > 0 && (
//             <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg mb-4">
//               <div className="flex items-center justify-between flex-wrap gap-4">
//                 <div className="flex items-center gap-4">
//                   <span className="text-sm font-medium text-blue-800">
//                     {selectedRows.size} rows selected
//                   </span>
//                   <div className="flex items-center gap-2">
//                     <span className="text-sm text-blue-700">
//                       Assign name to all selected:
//                     </span>
//                   </div>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <Select
//                     value={bulkAssignValue}
//                     onValueChange={setBulkAssignValue}
//                   >
//                     <SelectTrigger className="w-48">
//                       <SelectValue placeholder="Choose name to assign" />
//                     </SelectTrigger>
//                     <SelectContent
//                       position="popper"
//                       side="bottom"
//                       align="start"
//                       sideOffset={4}
//                     >
//                       {parentEntityOptions.map((option) => (
//                         <SelectItem key={option.value} value={option.value}>
//                           {option.label}
//                         </SelectItem>
//                       ))}
//                     </SelectContent>
//                   </Select>
//                   <Button
//                     onClick={handleBulkAssignment}
//                     size="sm"
//                     className="bg-blue-600 hover:bg-blue-700"
//                     disabled={!bulkAssignValue || updateEntityMutation.isPending}
//                   >
//                     {updateEntityMutation.isPending ? (
//                       <>
//                         <Loader2 className="w-4 h-4 mr-2 animate-spin" />
//                         Assigning...
//                       </>
//                     ) : (
//                       "Assign to Selected"
//                     )}
//                   </Button>
//                 </div>
//               </div>
//             </div>
//           )}

//           <div className="border rounded-lg overflow-hidden">
//             <ScrollArea className="h-[400px]">
//               <Table>
//                 <TableHeader>
//                   <TableRow className="bg-gray-50">
//                     {/* Select All Checkbox */}
//                     {isEditMode && (
//                       <TableHead className="w-12">
//                         <Checkbox
//                           checked={
//                             currentFilteredData.length > 0 &&
//                             selectedRows.size === currentFilteredData.length
//                           }
//                           onCheckedChange={handleSelectAll}
//                           ref={(ref) => {
//                             if (ref) {
//                               (ref as any).indeterminate =
//                                 selectedRows.size > 0 &&
//                                 selectedRows.size < currentFilteredData.length;
//                             }
//                           }}
//                         />
//                       </TableHead>
//                     )}
//                     {tableColumns.map((column) => (
//                       <TableHead key={column} className="min-w-[120px]">
//                         {column
//                           .replace(/_/g, " ")
//                           .replace(/\b\w/g, (l) => l.toUpperCase())}
//                       </TableHead>
//                     ))}
//                   </TableRow>
//                 </TableHeader>
//                 <TableBody>
//                   {currentFilteredData.map((row, index) => (
//                     <TableRow
//                       key={`${index}-${row.id || row.entity_name || index}`}
//                       className={`hover:bg-gray-50 ${
//                         selectedRows.has(index) ? "bg-blue-50" : ""
//                       }`}
//                     >
//                       {/* Row Selection Checkbox */}
//                       {isEditMode && (
//                         <TableCell>
//                           <Checkbox
//                             checked={selectedRows.has(index)}
//                             onCheckedChange={(checked) => handleRowSelect(index, checked)}
//                           />
//                         </TableCell>
//                       )}
//                       {tableColumns.map((column) => (
//                         <TableCell key={column}>
//                           {editingRow === index ? (
//                             // Edit mode for specific row
//                             column === "parentName" ? (
//                               // Dropdown for parent_name column
//                               <Select
//                                 value={editValues[column] || ""}
//                                 onValueChange={(value) => handleEditValueChange(column, value)}
//                               >
//                                 <SelectTrigger className="w-full min-w-[150px]">
//                                   <SelectValue placeholder="Select parent entity" />
//                                 </SelectTrigger>
//                                 <SelectContent
//                                   position="popper"
//                                   side="bottom"
//                                   align="start"
//                                   sideOffset={4}
//                                 >
//                                   {parentEntityOptions.map((option) => (
//                                     <SelectItem key={option.value} value={option.value}>
//                                       {option.label}
//                                     </SelectItem>
//                                   ))}
//                                 </SelectContent>
//                               </Select>
//                             ) : (
//                               // Regular input for other columns
//                               <Input
//                                 value={editValues[column] || ""}
//                                 onChange={(e) => handleEditValueChange(column, e.target.value)}
//                                 className="w-full min-w-[100px]"
//                               />
//                             )
//                           ) : (
//                             // Display mode
//                             <span
//                               className={`${
//                                 column.includes("name") ? "font-medium" : ""
//                               } ${
//                                 isEditMode && column === "parentName"
//                                   ? "cursor-pointer hover:bg-gray-100 px-2 py-1 rounded"
//                                   : ""
//                               }`}
//                               onClick={() => handleCellEdit(index, column)}
//                             >
//                               {row[column]?.toString() || "-"}
//                             </span>
//                           )}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </ScrollArea>
//           </div>
//         </CardContent>
//       </Card>

//       {/* Navigation Buttons */}
//       <div className="flex justify-between">
//         <Button variant="outline" onClick={() => setStep(2)} disabled={isUploading}>
//           Back
//         </Button>
//         <Button onClick={handleImport} className="bg-blue-600 hover:bg-blue-700">
//           {isUploading ? (
//             <>
//               <Loader2 className="w-4 h-4 mr-2 animate-spin" />
//               Importing...
//             </>
//           ) : (
//             `Import Data (${
//               validationData.filter((d) => d.status !== "error").length
//             } records)`
//           )}
//         </Button>
//       </div>
//     </div>
//   );
// };

import React, { useState, useCallback, useMemo } from "react";
import { Button } from "@shared/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";
import { Checkbox } from "@shared/ui/checkbox";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { ScrollArea } from "@shared/ui/scroll-area";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@shared/ui/table";
import {
  CheckCircleIcon,
  AlertTriangleIcon,
  Loader2,
  Edit,
  X,
  Filter,
} from "lucide-react";
import { toast } from "@shared/ui/use-toast";
import { useUpdateIdEntity } from "@features/onboarding/utility-setup/hooks";
import MultiSelectDropdown from "@shared/components/MultiSelectDropdown";

interface Step3Props {
  validationData: any[];
  filteredValidationData: any[];
  getTableColumns: () => string[];
  handleImport: () => void;
  isUploading: boolean;
  setStep: (step: number) => void;
  isEditMode: boolean;
  setIsEditMode: (value: boolean) => void;
  selectedRows: Set<number>;
  setSelectedRows: (value: Set<number>) => void;
  bulkAssignValue: string;
  setBulkAssignValue: (value: any) => void;
  parentEntityOptions: Array<{ value: string; label: string }>;
  setValidationData: (value: any[]) => void;
  validationFilter?: string;
  setValidationFilter?: (value: string) => void;
  dataUploadId: number | null;
}

export const Step3Component: React.FC<Step3Props> = ({
  validationData,
  // filteredValidationData,
  getTableColumns,
  handleImport,
  isUploading,
  setStep,
  isEditMode,
  setIsEditMode,
  selectedRows,
  setSelectedRows,
  bulkAssignValue,
  setBulkAssignValue,
  parentEntityOptions,
  setValidationData,
  // validationFilter = "all",
  // setValidationFilter,
  dataUploadId,
}) => {
  console.log("Step3Component rendered with validationData:", validationData);
  console.log("dataUploadId at step 3:", dataUploadId);
  const [validationFilter, setValidationFilter] = useState<
    "all" | "valid" | "error"
  >("all");

  // Normalize statuses -> only "valid" or "error"
  const normalizedData = useMemo(() => {
    return validationData.map((row) => ({
      ...row,
      status: row.status?.toLowerCase() === "error" ? "error" : "valid",
    }));
  }, [validationData]);

  // Apply filter
  const currentFilteredData = useMemo(() => {
    if (validationFilter === "all") return normalizedData;
    return normalizedData.filter((row) => row.status === validationFilter);
  }, [normalizedData, validationFilter]);

  const updateEntityMutation = useUpdateIdEntity();

  // Memoize filtered data to prevent recalculation on every render

  // Memoize validation stats to prevent recalculation
  const validationStats = useMemo(
    () => ({
      valid: validationData.filter((d) => d.status === "valid").length,
      warning: validationData.filter((d) => d.status === "warning").length,
      error: validationData.filter((d) => d.status === "error").length,
    }),
    [validationData]
  );

  // Optimized checkbox selection handlers
  const handleSelectAll = useCallback(
    (checked: boolean) => {
      if (checked) {
        const allIndices = new Set(
          currentFilteredData.map((_, index) => index)
        );
        setSelectedRows(allIndices);
      } else {
        setSelectedRows(new Set());
      }
    },
    [currentFilteredData, setSelectedRows]
  );

  const handleRowSelect = useCallback(
    (index: number, checked: boolean) => {
      setSelectedRows((prev) => {
        const newSelectedRows = new Set(prev);
        if (checked) {
          newSelectedRows.add(index);
        } else {
          newSelectedRows.delete(index);
        }
        return newSelectedRows;
      });
    },
    [setSelectedRows]
  );

  // Optimized edit mode toggle
  const handleEditModeToggle = useCallback(() => {
    setIsEditMode(!isEditMode);
    setSelectedRows(new Set());
    setBulkAssignValue("");
  }, [isEditMode, setIsEditMode, setSelectedRows, setBulkAssignValue]);

  // CREATE SIMPLIFIED PAYLOAD FROM SELECTED DATA
  const createPayloadFromSelectedData = useCallback(() => {
    const selectedData: any[] = [];

    selectedRows.forEach((selectedIndex) => {
      const rowData = currentFilteredData[selectedIndex];
      if (rowData) {
        selectedData.push({
          tags: rowData.tags || "",
          description: rowData.description || "",
          entity_name: rowData.entityName || rowData.entity_name || "",
          parent_name:
            parentEntityOptions.find((opt) => opt.value === bulkAssignValue)
              ?.label || bulkAssignValue,
          configuration_code:
            rowData.configurationCode || rowData.configuration_code || 0,
        });
      }
    });

    return selectedData;
  }, [selectedRows, currentFilteredData, parentEntityOptions, bulkAssignValue]);

  // HANDLE BULK ASSIGNMENT WITH DATA REPLACEMENT
  const handleBulkAssignment = useCallback(() => {
    if (!bulkAssignValue) {
      toast({
        title: "Error",
        description: "Please select a name to assign",
        variant: "destructive",
      });
      return;
    }

    if (selectedRows.size === 0) {
      toast({
        title: "Error",
        description: "Please select at least one row",
        variant: "destructive",
      });
      return;
    }

    if (!dataUploadId) {
      toast({
        title: "Error",
        description: "Data upload ID is missing",
        variant: "destructive",
      });
      return;
    }

    const payload = createPayloadFromSelectedData();
    console.log("Simplified Bulk Assignment Payload:", payload);

    updateEntityMutation.mutate(
      {
        id: dataUploadId,
        payload: payload,
      },
      {
        onSuccess: (response) => {
          console.log("✅ Mutation successful, response:", response);

          // Replace validation data with API response
          if (response?.result && Array.isArray(response.result)) {
            // Transform API response to match validation data structure
            const transformedData = response.result.map(
              (item: any, index: number) => ({
                ...item,
                entityName: item.entityName,
                parentName: item.parentName,
                configurationCode: item.configurationCode,
              })
            );

            // Replace the entire validation data with the response
            setValidationData(transformedData);

            // Clear selections and reset state
            setSelectedRows(new Set());
            setBulkAssignValue("");
            setIsEditMode(false);
            toast({
              title: "Success",
              description: "Successfully updated selected records",
              variant: "default",
            });
          }
        },
        onError: (error) => {
          console.error("❌ Mutation failed:", error);
          toast({
            title: "Error",
            description: "Failed to update records. Please try again.",
            variant: "destructive",
          });
        },
      }
    );
  }, [
    bulkAssignValue,
    selectedRows.size,
    dataUploadId,
    createPayloadFromSelectedData,
    updateEntityMutation,
    setValidationData,
    setSelectedRows,
    setBulkAssignValue,
    setIsEditMode,
    parentEntityOptions,
  ]);

  // Memoize table columns to prevent recalculation
  const tableColumns = useMemo(() => getTableColumns(), [getTableColumns]);

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="text-lg">Step 3: Review & Fix Data</CardTitle>
            <div className="flex items-center gap-2">
              {/* Status Filter Dropdown */}
              <div className="flex items-center gap-2">
                <Filter className="w-4 h-4 text-gray-500" />
                <Select
                  value={validationFilter}
                  onValueChange={(val) => setValidationFilter(val as any)}
                >
                  <SelectTrigger className="w-32">
                    <SelectValue placeholder="Filter by status" />
                  </SelectTrigger>
                  <SelectContent
                    position="popper"
                    side="bottom"
                    align="end"
                    sideOffset={4}
                  >
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="valid">Valid</SelectItem>
                    <SelectItem value="error">Error</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <Button
                variant={isEditMode ? "destructive" : "outline"}
                size="sm"
                onClick={handleEditModeToggle}
              >
                {isEditMode ? (
                  <>
                    <X className="w-4 h-4 mr-2" />
                    Exit Edit Mode
                  </>
                ) : (
                  <>
                    <Edit className="w-4 h-4 mr-2" />
                    Edit Mode
                  </>
                )}
              </Button>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="bg-gray-50 p-4 rounded-lg mb-4">
            <div className="flex items-center justify-between mb-2">
              <h3 className="font-medium">Validation Results</h3>
            </div>
            <div className="flex gap-4 text-sm">
              <span className="text-green-600 flex items-center gap-1">
                <CheckCircleIcon className="w-4 h-4" />
                {validationStats.valid} Valid
              </span>
              <span className="text-orange-600 flex items-center gap-1">
                <AlertTriangleIcon className="w-4 h-4" />
                {validationStats.warning} Warnings
              </span>
              <span className="text-red-600 flex items-center gap-1">
                <AlertTriangleIcon className="w-4 h-4" />
                {validationStats.error} Errors
              </span>
            </div>
            <p className="text-xs text-gray-600 mt-2">
              Showing {currentFilteredData.length} of {validationData.length}{" "}
              records
              {validationFilter !== "all" &&
                ` (filtered by ${validationFilter})`}
              . Fix errors and warnings before importing.
              {isEditMode
                ? " Edit mode is active - select rows for bulk assignment."
                : " Click Edit Mode to select rows for bulk assignment."}
            </p>
          </div>

          {/* Bulk Actions Panel */}
          {isEditMode && selectedRows.size > 0 && (
            <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg mb-4">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-4">
                  <span className="text-sm font-medium text-blue-800">
                    {selectedRows.size} rows selected
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-blue-700">
                      Assign name to all selected:
                    </span>
                  </div>
                </div>
                {/* <div className="flex items-center gap-2">
                  <Select 
                    value={bulkAssignValue} 
                    onValueChange={setBulkAssignValue}
                  >
                    <SelectTrigger className="w-48">
                      <SelectValue placeholder="Choose name to assign" />
                    </SelectTrigger>
                    <SelectContent
                      position="popper"
                      side="bottom"
                      align="start"
                      sideOffset={4}
                    >
                      {parentEntityOptions.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                          {option.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <Button
                    onClick={handleBulkAssignment}
                    size="sm"
                    className="bg-blue-600 hover:bg-blue-700"
                    disabled={!bulkAssignValue || updateEntityMutation.isPending}
                  >
                    {updateEntityMutation.isPending ? (
                      <>
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        Assigning...
                      </>
                    ) : (
                      "Assign to Selected"
                    )}
                  </Button>
                </div> */}

                <div className="flex items-center gap-2">
                  <MultiSelectDropdown
                    options={parentEntityOptions.map((option) => ({
                      label: option.label,
                      value: option.value,
                    }))}
                    maxSelection={1}
                    closeOnSelect={true}
                    placeholder="Choose name to assign"
                    className="p-0 min-w-[30%]"
                    onChange={(value) => {
                      // since maxSelection=1, value will be an array with single item
                      const selected = value?.[0] || null;
                      setBulkAssignValue(selected);
                    }}
                  />

                  <Button
                    onClick={handleBulkAssignment}
                    size="sm"
                    className="bg-blue-600 hover:bg-blue-700"
                    disabled={
                      !bulkAssignValue || updateEntityMutation.isPending
                    }
                  >
                    {updateEntityMutation.isPending ? (
                      <>
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        Assigning...
                      </>
                    ) : (
                      "Assign to Selected"
                    )}
                  </Button>
                </div>
              </div>
            </div>
          )}

          <div className="border rounded-lg overflow-hidden">
            <div className="border rounded-lg overflow-hidden">
        <ScrollArea className="h-[400px]">
          <Table>
            <TableHeader>
              <TableRow className="bg-gray-50">
                {isEditMode && (
                  <TableHead className="w-12">
                    <Checkbox
                      checked={
                        currentFilteredData.length > 0 &&
                        selectedRows.size === currentFilteredData.length
                      }
                      onCheckedChange={handleSelectAll}
                      ref={(ref) => {
                        if (ref) {
                          (ref as any).indeterminate =
                            selectedRows.size > 0 &&
                            selectedRows.size < currentFilteredData.length;
                        }
                      }}
                    />
                  </TableHead>
                )}
                {tableColumns.map((column) => (
                  <TableHead key={column} className="min-w-[120px]">
                    {column.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {currentFilteredData.map((row, index) => (
                <TableRow
                  key={`${index}-${row.id || row.entity_name || index}`}
                  className={`hover:bg-gray-50 ${selectedRows.has(index) ? "bg-blue-50" : ""}`}
                >
                  {isEditMode && (
                    <TableCell>
                      <Checkbox
                        checked={selectedRows.has(index)}
                        onCheckedChange={(checked) => handleRowSelect(index, checked)}
                      />
                    </TableCell>
                  )}
                  {tableColumns.map((column) => (
                    <TableCell key={column}>
                      <span className={column.includes("name") ? "font-medium" : ""}>
                        {row[column]?.toString() || "-"}
                      </span>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ScrollArea>
      </div>
          </div>
        </CardContent>
      </Card>

      {/* Navigation Buttons */}
      <div className="flex justify-between">
        <Button
          variant="outline"
          onClick={() => setStep(2)}
          disabled={isUploading}
        >
          Back
        </Button>
        <Button
          onClick={handleImport}
          className="bg-blue-600 hover:bg-blue-700"
        >
          {isUploading ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Importing...
            </>
          ) : (
            `Import Data (${
              validationData.filter((d) => d.status !== "error").length
            } records)`
          )}
        </Button>
      </div>
    </div>
  );
};
